const adaptRfbRequestBody = (body) => ({
  pointId: body.pointId[0].id,
  params: {
    merchantId: body.merchantId,
    secretKey: body.secretKey,
  },
});

export default adaptRfbRequestBody;
